import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum ETenantApplicationsRoute {
  tenantApplications = 'tenant-applications',
  list = 'list',
  details = 'details',
  create = 'create',
  createWithEstate = 'createWithEstate',
}

TaRoutes.addRoute({
  key: ETenantApplicationsRoute.tenantApplications,
  url: 'tenant-applications',
  children: [
    {
      key: ETenantApplicationsRoute.list,
      url: 'list',
    },
    {
      key: ETenantApplicationsRoute.details,
      url: 'detail/:id',
    },
    {
      key: ETenantApplicationsRoute.create,
      url: 'create',
    },
    {
      key: ETenantApplicationsRoute.createWithEstate,
      url: 'create/:estateId',
    },
  ],
});

export const tenantApplicationsRoutes: Routes = [
  {
    path: TaRoutes.getUrl([
      ETenantApplicationsRoute.tenantApplications,
      ETenantApplicationsRoute.list,
    ]),
    title: 'app.pages.applications.title',
    loadComponent: () =>
      import('./pages/tenant-applications-list/tenant-applications-list').then(
        (c) => c.TenantApplicationsListPage,
      ),
  },
  {
    path: TaRoutes.getUrl([
      ETenantApplicationsRoute.tenantApplications,
      ETenantApplicationsRoute.details,
    ]),
    title: 'app.pages.application_details.title',
    loadComponent: () =>
      import('./pages/tenant-application/tenant-application').then((c) => c.TenantApplicationPage),
  },
  {
    path: TaRoutes.getUrl([
      ETenantApplicationsRoute.tenantApplications,
      ETenantApplicationsRoute.create,
    ]),
    title: 'app.pages.new_application.title',
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'estates', level: 'authorize' },
    loadComponent: () =>
      import('./pages/create-tenant-application/create-tenant-application').then(
        (c) => c.CreateTenantApplicationPage,
      ),
  },
  {
    path: TaRoutes.getUrl([
      ETenantApplicationsRoute.tenantApplications,
      ETenantApplicationsRoute.createWithEstate,
    ]),
    title: 'app.pages.new_application.title',
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'estates', level: 'authorize' },
    loadComponent: () =>
      import('./pages/create-tenant-application/create-tenant-application').then(
        (c) => c.CreateTenantApplicationPage,
      ),
  },
];
